import React, { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import moment from 'moment'
import { saveAs } from 'file-saver'
import { first, groupBy, keys, noop, omit } from 'lodash'
import Modal from '@ublique/components/LoadingModal'
import Button from '@ublique/components/Button'
import ErrorsAccordion from 'components/ImportModal/ErrorsAccordion'

const MAX_ROWS = 1

const UploadError = ({ close, open, data }) => {
  const { errors, tryAgain = noop } = data

  const [isEmptyZipSection, setIsEmptyZipSection] = useState(false)
  const [isEmptyFilesSection, setIsEmptyFilesSection] = useState(false)

  const { t } = useTranslation(['UploadLog', 'Shell'])
  const setMainZipFileAsFirstAccordion = (data, isMainFile) => {
    const orderedData = groupBy(data, 'fileName')

    let mainKey
    keys(orderedData).forEach((key) => {
      if (key.endsWith('zip')) {
        const element = first(orderedData[key])
        if (element.zipMainFile) {
          mainKey = key
        }
      }
    })

    if (isMainFile) {
      return mainKey ? { [mainKey]: orderedData[mainKey] } : undefined
    } else {
      if (mainKey) {
        return omit(orderedData, mainKey)
      } else {
        return orderedData
      }
    }
  }
  const errorsGroups = useMemo(() => groupBy(errors, 'fileName'), [errors])

  const downloadLogs = useCallback(() => {
    const reduceError = (acc, { reason }) => `${acc} - ${t(reason)}\n\n`

    // Create a text listed of various products
    let text = `Upload log errors :  \n\n`
    text =
      text +
      keys(errorsGroups).reduce(
        (acc, file) =>
          `${acc}\n${file}\n${errorsGroups[file].reduce(reduceError, '')}`,
        ''
      )

    const blobText = new Blob([text], { type: 'text/plain' })
    const fileName = `Upload_Error_${moment().format('YYYY-MM-DD_HH-mm')}.txt`

    saveAs(blobText, fileName)
  }, [errorsGroups])

  const tryAgainFunc = useCallback(() => {
    tryAgain()
    close()
  })

  const groupBySheetName = (data, isMainFile) => {
    const toRet = setMainZipFileAsFirstAccordion(data, isMainFile)
    if (!toRet) {
      isMainFile ? setIsEmptyZipSection(true) : setIsEmptyFilesSection(true)
      return []
    }
    return Object.entries(toRet)
  }

  const modalBody = () => {
    return (
      <>
        <h5>{t('UPLOAD_ERROR_MESSAGE')}</h5>
        {!isEmptyZipSection && (
          <>
            <p className='error-section-upload'>
              <strong>{t('UploadLog.ZIP_SECTION')}</strong>
            </p>
            <ErrorsAccordion
              errorsBySheetList={groupBySheetName(errors, true)}
              t={t}
              type='upload'
            />
          </>
        )}
        {!isEmptyFilesSection && (
          <>
            <p className='error-section-upload'>
              <strong>{t('UploadLog.FILES_SECTION')}</strong>
            </p>
            <ErrorsAccordion
              errorsBySheetList={groupBySheetName(errors, false)}
              t={t}
              type='upload'
            />
          </>
        )}
      </>
    )
  }

  return (
    <Modal
      id='modal-import-error'
      preventCloseOnClickOutside
      modalHeading={t('UPLOAD_ERROR_TITLE')}
      open={open}
      onRequestClose={close}
      size='md'
      className='import-service-modal'
      footerCustom={
        <>
          <Button kind='secondary' onClick={close}>
            {t('Button.CLOSE')}
          </Button>
          <Button
            disabled={errors.length <= MAX_ROWS}
            kind='primary'
            onClick={downloadLogs}
          >
            {t('Button.DOWNLOAD_ERRORS_LOGS')}
          </Button>
          <Button kind='primary' onClick={tryAgainFunc}>
            {t('Button.TRY_AGAIN')}
          </Button>
        </>
      }
    >
      {modalBody()}
    </Modal>
  )
}

export default UploadError
